import { action, makeObservable, observable } from 'mobx'

import { sortBy } from '../../../../utils/helpers'

class Store {
    @observable loading = true

    @observable type = 'product'

    @observable id = ''

    @observable clientId = null

    @observable portfolioId = 0

    @observable dataviewerLink

    @observable processing = false

    clients = []

    types = [
        // {
        //     value: 'portfolio',
        //     label: 'Portfolio',
        // },
        {
            value: 'product',
            label: 'Product',
        },
    ]

    constructor(store) {
        makeObservable(this)
        this.appStore = store
    }

    changeId = ({ value }) => {
        this.id = value
    }

    @action
    reset = () => {
        this.processing = false
        this.type = 'product'
        this.id = ''
        this.portfolioId = 0
        this.clientId = null
    }

    @action
    changeType = ({ value }) => {
        this.type = value

        if (value === 'portfolio') {
            this.portfolioId = 0
        } else {
            this.clientId = null
        }
    }

    changeClientId = (obj) => {
        this.clientId = obj
    }

    changePortfolioId = ({ value }) => {
        this.portfolioId = value
    }

    getClients = async () => {
        const { appStore } = this
        try {
            const response = await appStore.http.get('/client')
            const { clients } = response

            this.clients = sortBy(clients, 'name')
                .map(({ clientId, name }) => ({
                    value: clientId,
                    label: `[${clientId}] - ${name}`,
                }))
        } catch (e) {
            console.error(e)
            appStore.addNotification(null, 'Error looading clients', 'error')
            this.clients = []
        }

        this.loading = false
    }

    movePortfolioToNewClient = async () => {
        /**
         * 	var url = application.gatewayUrl & "utility/movePortfolioToNewClient?" & "portfolioId=" & currentPortfolioId & "&newClientId=" & newClientId & "&requestingUserId=" & mysession.get("userId");
         */
        const { appStore, id, clientId } = this
        const { tokenData } = appStore
        const { userId } = tokenData

        try {
            const a = await appStore.http.get(`/utility/movePortfolioToNewClient?portfolioId=${id}&newClientId=${clientId.value}&requestingUserId=${userId}`)
            console.log('here', a)
            appStore.addNotification(null, 'Portfolio moved to a new client', 'success')
        } catch (e) {
            console.error(e)
            appStore.addNotification(null, 'Error moving portfolio to a new client', 'error')
        }
        this.reset()
    }

    moveProductToNewPortfolio = async () => {
        const { appStore, id, portfolioId } = this
        const { tokenData } = appStore
        const { userId } = tokenData

        try {
            await appStore.http.post('/utility/moveProductToNewPortfolio', JSON.stringify({
                productId: Number(id),
                portfolioId: Number(portfolioId),
            }))
            appStore.addNotification(null, 'Request to move product to a new portfolio received', 'success')
            this.dataviewerLink = `/intranet/dataViewer2?schema=explori_v3&tablename=utility_event&filter=userId|eq|${userId}`
        } catch (e) {
            console.error(e)
            appStore.addNotification(null, 'Error moving product to a new portfolio', 'error')
        }
        this.reset()
    }

    move = () => {
        const { type } = this

        this.processing = true

        if (type === 'portfolio') {
            this.movePortfolioToNewClient()
        } else {
            this.moveProductToNewPortfolio()
        }
    }
}

export default Store
